import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { sprintf } from 'sprintf-js';
import { Modal } from 'react-bootstrap';
import loader from '../assets/loader.svg';
import moment from 'moment';

import Heading from '../components/Heading';
import * as API from '../services/api';
import SearchBar from '../components/SearchBar';
import { SPECIAL_CLIENTS_FOR_FREE_FEE } from '../constants';
import Alert from '../components/Common/Alert';

class CopyrightRegList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      coregs: [],
      initCoregs: [],
      showDetailModal: false,
      selectedCoreg: null,
      loading: false,
    };
  }

  componentWillMount() {
    if (this.props.profile.id) {
      this.setState({ loading: true });
      this.loadCoregs(this.props.profile.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.profile.id !== nextProps.profile.id) {
      this.loadCoregs(nextProps.profile.id);
    }
  }

  loadCoregs(userId) {
    API.getCoregs(userId).then((res) => {
      const coregs = _.orderBy(res, [(creg) => creg.date_created], ['desc']);
      this.setState({ coregs, initCoregs: coregs, loading: false });
    });
  }

  getCoregData = (data) => {
    data = JSON.parse(data);
    return data.workTitles || [];
  };

  handleSearch = (e) => {
    e.preventDefault();
    const searchText = e.target.value;
    this.setState({ searchText }, () => {
      this.searchCoreg(searchText);
    });
  };

  clearSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: '', coregs: this.state.initCoregs });
  };

  searchCoreg = (searchText) => {
    const { initCoregs } = this.state;
    let searchedCoregs = _.filter(
      initCoregs,
      (coreg) =>
        sprintf('%06d', coreg.id)
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        _.filter(this.getCoregData(coreg.data), (data) =>
          data.title.toLowerCase().includes(searchText.toLowerCase())
        ).length > 0
    );

    searchedCoregs = _.orderBy(
      searchedCoregs,
      [(creg) => creg.date_created],
      ['desc']
    );

    this.setState({ coregs: searchedCoregs });
  };

  handleCoreg(coreg) {
    this.setState({ showDetailModal: true, selectedCoreg: coreg });
  }

  getPrePayUser() {
    const prePayUserIndex = SPECIAL_CLIENTS_FOR_FREE_FEE.findIndex(user => user.email.includes(this.props.profile.email));

    if (prePayUserIndex === -1) return null;

    return SPECIAL_CLIENTS_FOR_FREE_FEE[prePayUserIndex];
  }

  getLeftCoregOfPrePayUser(prePayUser) {
    const maxCoregOfPrePayUser = prePayUser.cregCount;
    const currentCregCount = this.props.profile.creg_count;
    
    return maxCoregOfPrePayUser >  currentCregCount ? maxCoregOfPrePayUser - currentCregCount : 0;
  }

  render() {
    const { coregs, searchText, selectedCoreg, loading } = this.state;
    const prePayUser = this.getPrePayUser();

    return (
      <div className="copyright-list-page">
        <Heading text="U.S. Copyright Office Registrations" />
        <div className="text-center">
          <a
            type="button"
            className="btn btn-link btn-register-new"
            href="/copyright-reg"
          >
            Register Your Copyrights
          </a>
        </div>

        <div className="text-center">
          Please note that it can take 6-10 months from the time you submit for
          your registration to be approved. This includes time for both Cosynd
          and the Copyright Office to review your application and research any
          potential issues/conflicts. Because the process can be lengthy, you do
          not have to wait to distribute your work. As well, copyright
          protection exists for creators from the moment the work is fixed in a
          tangible/readable form and some benefits are automatically granted to
          you. You can find out more about what those benefits are{' '}
          <a
            href="https://cosynd.zendesk.com/hc/en-us/articles/115006546708-What-are-the-rights-of-a-copyright-holder-"
            target="_blank"
          >
            here
          </a>
          .
        </div>
        <div className="agreement-page dashboard">
          <SearchBar
            searchText={searchText}
            handleSearch={this.handleSearch}
            clearSearch={this.clearSearch}
          />
          <div className="relative">
            {
              prePayUser && (
                <Alert messages={[
                  `The remaining free Copyright Registrations: ${this.getLeftCoregOfPrePayUser(prePayUser)}`
                ]} />
              )
            }
            {coregs.length > 0 ? (
              <div className="agreement-wrapper">
                {coregs.map((coreg, index) => (
                  <div
                    key={index}
                    className="creg-view"
                    onClick={() => this.handleCoreg(coreg)}
                  >
                    <div className="title-view">
                      <div className="title">
                        <b>{`#${sprintf('%06d', coreg.id)}`}</b>
                      </div>
                      <br />
                      {this.getCoregData(coreg.data).map((title, idx) => (
                        <div className="sub-title" key={idx}>
                          {title.title}
                        </div>
                      ))}
                    </div>
                    <div
                      className={`details text-right ${
                        coreg.is_success && 'text-blue'
                      }`}
                    >
                      <b>{coreg.is_success ? 'CLOSED' : 'PENDING'}</b>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center">
                {searchText === '' && loading && (
                  <img src={loader} alt="Loading spinner" />
                )}
              </div>
            )}
          </div>
        </div>

        <Modal
          className="copyright-detail-modal"
          show={this.state.showDetailModal}
          onHide={() => this.setState({ showDetailModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedCoreg && `#${sprintf('%06d', selectedCoreg.id)}`}
            </Modal.Title>
          </Modal.Header>
          {selectedCoreg && (
            <Modal.Body>
              <div className="creg-view">
                <div>
                  <ul>
                    {this.getCoregData(selectedCoreg.data).map((title, idx) => (
                      <li className="sub-title" key={idx}>
                        {title.title}
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <div
                    className={`details text-right ${
                      selectedCoreg.is_success && 'text-blue'
                    }`}
                  >
                    <b>{selectedCoreg.is_success ? 'CLOSED' : 'PENDING'}</b>
                  </div>
                  <div className={`details text-right`}>
                    {moment(selectedCoreg.date_created).format('MM-DD-YYYY')}
                  </div>
                </div>
              </div>
            </Modal.Body>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, null)(withRouter(CopyrightRegList));



// WEBPACK FOOTER //
// src/pages/CopyrightRegList.jsx